import { gql } from '@apollo/client';

export const REMOVE_AWAY_GOALIE = gql`
  mutation RemoveAwayGoalie($gameId: Int!) {
    update_schedule_by_pk(
      pk_columns: { id: $gameId }
      _set: { awayGoalie: null }
    ) {
      id
    }
  }
`;

export const REMOVE_HOME_GOALIE = gql`
  mutation RemoveHomeGoalie($gameId: Int!) {
    update_schedule_by_pk(
      pk_columns: { id: $gameId }
      _set: { homeGoalie: null }
    ) {
      id
    }
  }
`;

export const SET_AWAY_GOALIE = gql`
  mutation SetAwayGoalie($gameId: Int!, $playerId: Int!) {
    update_schedule_by_pk(
      pk_columns: { id: $gameId }
      _set: { awayGoalie: $playerId }
    ) {
      id
    }
  }
`;

export const SET_HOME_GOALIE = gql`
  mutation SetHomeGoalie($gameId: Int!, $playerId: Int!) {
    update_schedule_by_pk(
      pk_columns: { id: $gameId }
      _set: { homeGoalie: $playerId }
    ) {
      id
    }
  }
`;
